<template>
  <div>
    <section style="margin-left: 20px; margin-top: 10px">
      <button
        @click.prevent="onSubmit()"
        class="btn btn-danger btn-sm btn-block margin-bottom"
      >
        <i class="fa fa-search"></i> Search
      </button>

      <div class="box box-solid">
        <div class="box-body">
          <form role="form">
            <div class="form-group">
              <label for="purchaseDate" class="control-label text-primary"
                >Purchase Date Range</label
              >
              <div class="input-group">
                <input
                  placeholder="purchase date range"
                  type="text"
                  class="form-control"
                  id="purchaseDate"
                />
                <div class="input-group-addon">
                  <i class="fa fa-calendar"></i>
                </div>
              </div>
            </div>

            <hr style="border: 0.5px solid #efefef" />
            <div class="form-group">
              <label for="code" class="control-label text-primary">
                Activation Code
              </label>
              <div class="input-group">
                <input
                  v-model="activationFilter.code"
                  placeholder="activation ode"
                  type="text"
                  class="form-control"
                  id="code"
                />
                <div class="input-group-addon">
                  <i class="fa fa-superpowers"></i>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="partyEmail" class="control-label text-primary">
                Party Email
              </label>
              <div class="input-group">
                <input
                  v-model="activationFilter.partyEmail"
                  placeholder="email address"
                  type="text"
                  class="form-control"
                  id="partyEmail"
                />
                <div class="input-group-addon">
                  <i class="fa fa-envelope-o"></i>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="partyEmail" class="control-label text-primary">
                Party Name
              </label>
              <div class="input-group">
                <input
                  v-model="activationFilter.partyName"
                  placeholder="party name"
                  type="text"
                  class="form-control"
                  id="partyName"
                />
                <div class="input-group-addon">
                  <i class="fa fa-user"></i>
                </div>
              </div>
            </div>

            <hr style="border: 0.5px solid #efefef" />
            <div class="form-group">
              <label class="control-label text-primary"
                >Transaction Types</label
              >
              <br />
              <input
                type="checkbox"
                id="ttypeCreate"
                value="create"
                v-model="activationFilter.transactionType"
              />
              Create<br />
              <input
                type="checkbox"
                id="ttypeCreateFree"
                value="create_free"
                v-model="activationFilter.transactionType"
              />
              Create Free<br />
              <input
                type="checkbox"
                id="ttypeCreateTeaching"
                value="create_teaching"
                v-model="activationFilter.transactionType"
              />
              Create Teaching<br />
              <input
                type="checkbox"
                id="ttypeRenew"
                value="renew"
                v-model="activationFilter.transactionType"
              />
              Renew
            </div>

          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      activationFilter: null,
    };
  },
  created() {
    // initialize the filter values from the store.
    // this can then be persisted to DB.
    this.activationFilter = this.filter;
    // this.statePrtrGetData();
  },
  computed: {
    ...mapGetters("activation", ["isError", "isLoading", "filter"]),
  },
  watch: {
    $route: "fetchData",
  },
  methods: {
    fetchData() {
      if (
        this.$route.path == "/activation" &&
        this.$route.query.submit == "true"
      ) {
        this.onSubmit();
      }
    },
    onSubmit() {
      var date = $("#purchaseDate").val();
      if (date != undefined || date != "") {
        var res = date.split(" - ");
        this.activationFilter.purchaseDate_From = res[0];
        this.activationFilter.purchaseDate_To = res[1];
      }

      this.$store.dispatch("activation/setFilter", this.activationFilter);
    },
  },
  mounted() {
    $("#purchaseDate").daterangepicker({ autoUpdateInput: false });
    $("#purchaseDate").on("apply.daterangepicker", function (ev, picker) {
      $(this).val(
        picker.startDate.format("MM/DD/YYYY") +
          " - " +
          picker.endDate.format("MM/DD/YYYY")
      );
    });
    $("#purchaseDate").on("cancel.daterangepicker", function (ev, picker) {
      $(this).val("");
    });

    this.activationFilter = this.filter;

    if (this.$route.query.submit == "true") {
      this.onSubmit();
    }
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/paywall/activation/ActivationFilter.vue